import { getDisabledButtonWithLabel } from './utils'

const BLOCKS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
}

const TYPES = {
  DIGITAL_PROOF_FROM_PRINTER: 'DIGITAL_PROOF_FROM_PRINTER',
  DIGITAL_PROOF_SENT_TO_CLIENT: 'DIGITAL_PROOF_SENT_TO_CLIENT',
  DIGITAL_PROOF_SIGNED_BY_CLIENT: 'DIGITAL_PROOF_SIGNED_BY_CLIENT',
  STATEMENT_OF_WORK: 'STATEMENT_OF_WORK',
  DOWNLOAD_ALL: 'DOWNLOAD_ALL',
  DOWNLOAD_FLYER_DESIGN: 'DOWNLOAD_FLYER_DESIGN',
  DOWNLOAD_FLYER_CODES: 'DOWNLOAD_FLYER_CODES',
  DOWNLOAD_PRINTING_SUMMARY: 'DOWNLOAD_PRINTING_SUMMARY',
  DOWNLOAD_AUDIENCE_FLYER: 'DOWNLOAD_AUDIENCE_FLYER',
}

const BUTTON_TYPES = {
  DOWNLOAD: 'DOWNLOAD',
  SENT: 'SENT',
  UPLOAD: 'UPLOAD',
  DELETE: 'DELETE',
}

const INITIAL_DATA = {
  [BLOCKS.LEFT]: [
    {
      title: 'Digital Proof',
      items: {
        [TYPES.DIGITAL_PROOF_FROM_PRINTER]: {
          title: 'Digital Proof from printer',
          subTitle: 'The digital proof generated by printer',
          buttons: [
            BUTTON_TYPES.UPLOAD,
            BUTTON_TYPES.DOWNLOAD,
            BUTTON_TYPES.DELETE,
          ],
        },
        // [TYPES.DIGITAL_PROOF_SENT_TO_CLIENT]: {
        //   title: 'Digital Proof sent to client',
        //   subTitle: 'Has Digital Proof been sent to client to sign?',
        //   buttons: [BUTTON_TYPES.SENT],
        // },
        // [TYPES.DIGITAL_PROOF_SIGNED_BY_CLIENT]: {
        //   title: 'Digital Proof signed by client',
        //   subTitle: 'The digital proof signed by client',
        //   buttons: [
        //     BUTTON_TYPES.UPLOAD,
        //     BUTTON_TYPES.DOWNLOAD,
        //     BUTTON_TYPES.DELETE,
        //   ],
        // },
      },
    },
    {
      title: 'Contracts',
      items: {
        [TYPES.STATEMENT_OF_WORK]: {
          title: 'Statement of Work',
          subTitle: 'Statement of Work signed by client',
          buttons: [
            BUTTON_TYPES.UPLOAD,
            BUTTON_TYPES.DOWNLOAD,
            BUTTON_TYPES.DELETE,
          ],
        },
      },
    },
  ],
  [BLOCKS.RIGHT]: [
    {
      title: 'Printing Requirements',
      items: {
        [TYPES.DOWNLOAD_ALL]: {
          title: 'Download All',
          subTitle: 'Download all documents outlined below',
          buttons: [BUTTON_TYPES.DOWNLOAD],
        },
        [TYPES.DOWNLOAD_FLYER_DESIGN]: {
          title: 'Flyer Design',
          subTitle: 'Download flyer design (pdf)',
          buttons: [BUTTON_TYPES.DOWNLOAD],
        },
        [TYPES.DOWNLOAD_FLYER_CODES]: {
          title: 'Flyer Codes',
          subTitle: 'Download flyer codes & QR scan links (csv)',
          buttons: [BUTTON_TYPES.DOWNLOAD],
        },
        [TYPES.DOWNLOAD_PRINTING_SUMMARY]: {
          title: 'Printing Summary',
          subTitle: 'Download printing summary (csv)',
          buttons: [BUTTON_TYPES.DOWNLOAD],
        },
        [TYPES.DOWNLOAD_AUDIENCE_FLYER]: {
          title: 'Audience Flyer PDF',
          subTitle: 'Generate flyer PDF with audience variables',
          buttons: [BUTTON_TYPES.DOWNLOAD],
        },
      },
    },
  ],
}

const disabledUploadButton = getDisabledButtonWithLabel('Upload')
const disabledDownloadButton = getDisabledButtonWithLabel('Download')
const disabledDeleteButton = getDisabledButtonWithLabel('Delete')

const EXPORT_CSV_TYPES = {
  BASIC_TRACKING: 'BASIC_TRACKING',
  ADVANCED_TRACKING: 'ADVANCED_TRACKING',
  SUMMARY: 'SUMMARY',
  INSERTS_TRACKING: 'INSERTS_TRACKING',
}

const EXPORT_HEADERS = {
  [EXPORT_CSV_TYPES.BASIC_TRACKING]: [
    'City',
    'Redemption Codes',
    'Pack Codes',
    'QR URL',
  ],
  [EXPORT_CSV_TYPES.ADVANCED_TRACKING]: ['City', 'Redemption Codes', 'QR URL'],
  [EXPORT_CSV_TYPES.SUMMARY]: [
    'Cities',
    'Total Flyers',
    'Total Pack',
    'Flyers/Pack',
    'Redemption Codes',
    'Pack Codes',
  ],
  [EXPORT_CSV_TYPES.INSERTS_TRACKING]: [
    'Client Codes',
    'Internal Flyer Codes',
    'Flyer QR URL',
    'Pack QR URL',
    'Affiliate',
  ],
}

const TRACKING_TYPES = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
}

export {
  INITIAL_DATA,
  BUTTON_TYPES,
  TYPES,
  BLOCKS,
  disabledUploadButton,
  disabledDownloadButton,
  disabledDeleteButton,
  EXPORT_CSV_TYPES,
  EXPORT_HEADERS,
  TRACKING_TYPES,
}
